import { sendGAEvent } from '../utils';

export enum NDBEvents {
  CONFIRM_EMAIL_POPUP_APPEARANCE = 'ndb_confirm_email_popup_appearance',
  EMAIL_VERIFIED_POPUP_APPEARANCE = 'ndb_email_verified_popup_appearance',
  PROMO_CODE_AUTOFILL = 'promo_ndb_code_autofill',
}

interface INDBEmailVerifiedPopupAppearanceEvent {
  type: 'hide' | 'activate';
}

interface IPromoNDBCodeAutofillEvent {
  code: string;
}

/**
 * @description Sends a Google Analytics event when the "Verify Email" NDB popup appears.
 * The event name is `ndb_confirm_email_popup_appearance` and the category is `ndb popups`.
 */
export const sendNDBConfirmEmailPopupAppearanceEvent = () => {
  sendGAEvent(NDBEvents.CONFIRM_EMAIL_POPUP_APPEARANCE, {
    event_category: 'ndb_popups',
  });
};

/**
 * @param data - Object containing the type of interaction that ended the popup.
 * @description Sends a Google Analytics event when the "Email Verified" NDB popup appears/closes.
 */
export const sendNDBEmailVerifiedPopupAppearanceEvent = (
  data: INDBEmailVerifiedPopupAppearanceEvent
) => {
  sendGAEvent(NDBEvents.EMAIL_VERIFIED_POPUP_APPEARANCE, {
    event_category: 'ndb_popups',
    ...data,
  });
};

/**
 * @param data - Object containing the autofilled coupon code.
 * @description Sends a Google Analytics event when the saved NDB coupon is automatically
 * inserted into the promocode field on /promotions, whether after the Activate Bonus click
 * or after the automatic redirect.
 * The event name is `promo_ndb_code_autofill` and the category is `promo`.
 */
export const sendPromoNDBCodeAutofillEvent = (
  data: IPromoNDBCodeAutofillEvent
) => {
  sendGAEvent(NDBEvents.PROMO_CODE_AUTOFILL, {
    event_category: 'promo',
    ...data,
  });
};
